import React from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";

const shimmer = keyframes`
  0%   { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

const Loader = () => (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      zIndex: 9999,
      bgcolor: "rgba(0,0,0,0.45)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Typography
        sx={{
          color: "#a0ef8a",
          fontSize: { xs: "3rem", sm: "5rem" },
          fontWeight: 900,

          letterSpacing: "-0.06em",
          lineHeight: 0.8,
          mb: { xs: "24px", sm: "40px" },
          fontFamily: "Arial, sans-serif",
          filter: "drop-shadow(0 0 12px rgba(160,239,138,0.25))",
        }}
      >
        TifoXR
      </Typography>

      <Box
        sx={{
          width: { xs: "80vw", sm: 320 },
          maxWidth: 320,
          height: 4,
          bgcolor: "rgba(160,239,138,0.1)",
          borderRadius: "99px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            height: "100%",
            width: "45%",
            background: "linear-gradient(90deg, transparent, #a0ef8a, transparent)",
            animation: `${shimmer} 1.2s infinite ease-in-out`,
          }}
        />
      </Box>
    </Box>
  </Box>
);

export default Loader;
